/*
	Breadcrumb component for navigation
	Displays the navigation path based on the current URL
	Uses react-router-dom for links and location management
*/
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

// Breadcrumb component
const Breadcrumb: React.FC = () => {
	const location = useLocation();
	const pathnames = location.pathname.split('/').filter(Boolean);

	// Mapping segments URL to readable names
	const breadcrumbNameMap: Record<string, string> = {
		edit: 'Éditer',
		manage: 'Gérer',
		new: 'Créer',
		app: 'Accueil',

		users: 'Utilisateurs',

		badgeMovements: 'Mouvements de badges',
		'from-badge': 'Activités depuis Badges',

		customersDashboard: 'Tableau de bord clients',

		quotes: 'Devis',
		quoteVersions: 'Versions de devis',
		quoteLines: 'Lignes de devis',

		customers: 'Clients',
		tiers: 'Tiers',
		addresses: 'Adresses',
		contacts: 'Contacts',

		customerOrders: 'Commandes clients',

		projects: 'Affaires',
		activities: 'Activités',
		logisticElements: 'Éléments logistiques',

		customerInvoices: 'Factures clients',
		advances: 'Acomptes',
		creditNotes: 'Avoirs',

		suppliersDashboard: 'Tableau de bord fournisseurs',
		suppliers: 'Fournisseurs',
		orders: 'Commandes',
		orderVersions: 'Versions de commande',
		orderLines: 'Lignes de commande',
		expenses: 'Dépenses',

		results: 'Résultats',

		settings: 'Paramètres',
		products: 'Produits',
		produits: 'Produits',
		services: 'Services',
		tva: 'TVA',
		taxrates: 'Taux de TVA',
		depenses: 'Dépenses',
		contracts: 'Contrats',
		supplierInvoices: 'Factures fournisseurs',
		costCenters: 'Centres de coûts',
		costCenterCategories: 'Catégories de centres de coûts',
		infrastructure: 'Infrastructure',
		logo: 'Logo',
	};

	// Render the breadcrumb navigation
	return (
		<nav className="text-sm text-gray-500">
			{pathnames.length === 0 ? (
				<span>Accueil</span>
			) : (
				pathnames.map((value, index) => {
					const last = index === pathnames.length - 1;
					const to = `/${pathnames.slice(0, index + 1).join('/')}`;
					const displayName = breadcrumbNameMap[value] || value;

					return last ? (
						<span key={to} className="font-medium text-gray-700">
							{displayName}
						</span>
					) : (
						<span key={to}>
							<NavLink to={to} className="hover:underline">
								{displayName}
							</NavLink>
							<span className="mx-2">&gt;</span>
						</span>
					);
				})
			)}
		</nav>
	);
};

// Export the component
export default Breadcrumb;
